module.exports = __webpack_public_path__ + "img/make.9a9ff9ec.jpg";